import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import PhotoPage from './PhotoPage';
import MemoryDetail from './MemoryDetail';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/memory/:id" element={<MemoryDetail />} />
        {/* Keep old photo routes for backward compatibility */}
        <Route path="/photo/:photoId" element={<PhotoPage />} />
      </Routes>
    </Router>
  </React.StrictMode>
);
